import React from 'react';

const ServiceCard = ({ service }) => {
    return (
        <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                {/* Icon/Image Section */}
                <div className="relative h-96 md:h-auto">
                    {service.image ? (
                        <img
                            src={service.image}
                            alt={service.title}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full bg-gradient-to-br from-stone-200 to-amber-200 flex items-center justify-center">
                            <span className="text-9xl" role="img" aria-label="service icon">
                                {service.icon}
                            </span>
                        </div>
                    )}
                </div>

                {/* Content Section */}
                <div className="p-8 md:p-12 flex flex-col justify-center">
                    <h3 className="text-3xl font-semibold text-gray-900 mb-8">{service.title}</h3>

                    <div className="space-y-6 mb-8">
                        {service.duration && (
                            <div className="flex items-center text-gray-700">
                                <svg className="w-6 h-6 mr-4 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div>
                                    <span className="font-semibold text-lg">Duration:</span>
                                    <span className="ml-2 text-lg">{service.duration}</span>
                                </div>
                            </div>
                        )}

                        {service.price && (
                            <div className="flex items-center text-gray-700">
                                <svg className="w-6 h-6 mr-4 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                </svg>
                                <div>
                                    <span className="font-semibold text-lg">Starting at:</span>
                                    <span className="ml-2 text-2xl font-bold text-amber-600">${service.price}</span>
                                    <span className="ml-1 text-gray-600">per session</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Description */}
                    <div className="prose prose-lg max-w-none">
                        <p className="text-gray-700 leading-loose text-lg font-light">
                            {service.description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceCard;